/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SuccessResponse_ReportIndex_ } from '../models/SuccessResponse_ReportIndex_';
import type { SuccessResponse_SavedReport_ } from '../models/SuccessResponse_SavedReport_';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AiWeeklyService {
    /**
     * List Ai Weekly Reports
     * @returns SuccessResponse_ReportIndex_ Successful Response
     * @throws ApiError
     */
    public static listAiWeeklyReportsApiV1AiWeeklyReportsGet(): CancelablePromise<SuccessResponse_ReportIndex_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/ai-weekly-reports',
        });
    }
    /**
     * Get Ai Weekly Report
     * @returns SuccessResponse_SavedReport_ Successful Response
     * @throws ApiError
     */
    public static getAiWeeklyReportApiV1AiWeeklyReportsWeekStartGet({
        weekStart,
        revision,
        view,
    }: {
        weekStart: string,
        revision?: (number | null),
        view?: (string | null),
    }): CancelablePromise<SuccessResponse_SavedReport_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/ai-weekly-reports/{week_start}',
            path: {
                'week_start': weekStart,
            },
            query: {
                'revision': revision,
                'view': view,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
